var _style, _path, _path2, _path3, _line, _line2, _line3, _polyline, _path4, _line4, _line5, _line6, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEscalation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89.8 92.9",
    style: {
      enableBackground: "new 0 0 89.8 92.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.escalation0{fill:none;stroke:#D99A29;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.escalation01{fill:none;stroke:#3949ab;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "escalation0",
    d: "M46.4,79.8c4.3,0.8,7.6,4.8,10.1,8.3c2.5,3.5,7.3,3.3,7.3,3.3V50.2c-4.4-0.5-6.6,2.1-6.6,2.1 C49.4,62.4,39,61.6,39,61.6H27.1c-2,0-3.6,1.6-3.6,3.6v9.6c0,2,1.6,3.6,3.6,3.6H39V67.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "escalation0",
    d: "M28.5,78.3v11.1h2.3c2.1,0,3.8-1.5,4.1-3.6l0.9-7.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "escalation0",
    d: "M63.9,65.5c3.6,0,6.5,2.9,6.5,6.5c0,3.6-2.9,6.5-6.5,6.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "escalation0",
    x1: 73.7,
    y1: 62.3,
    x2: 82.4,
    y2: 55.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "escalation0",
    x1: 74.4,
    y1: 81.4,
    x2: 82.6,
    y2: 88.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "escalation0",
    x1: 88.4,
    y1: 72.8,
    x2: 76.8,
    y2: 72.8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "escalation01",
    points: "21,88.9 1,88.9 1,21.1 20.4,1 74.2,1 74.2,51.7 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "escalation01",
    d: "M20.9,1v11.9c0,4.8-3.9,8.6-8.6,8.6H1"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "escalation01",
    x1: 64.7,
    y1: 14.6,
    x2: 35,
    y2: 14.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "escalation01",
    x1: 64.7,
    y1: 25.5,
    x2: 35,
    y2: 25.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "escalation01",
    x1: 64.7,
    y1: 37,
    x2: 10.9,
    y2: 37
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "escalation0",
    d: "M22.7,74c-2,0-3.6-1.6-3.6-3.6c0-2,1.6-3.6,3.6-3.6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalation);
export default __webpack_public_path__ + "static/media/escalation.6ad762b757b444d47a2caceaabfb9210.svg";
export { ForwardRef as ReactComponent };